// alertHelper.ts
import Swal from "sweetalert2";

const showAlert = (type: "success" | "info" | "warning" | "error", message: string) => {
  Swal.fire({
    position: "top-end",
    icon: type,
    title: message,
    showConfirmButton: false,
    timer: type === "error" ? (10 * 1000) : 1500,
  });
};

export const showSuccessAlert = (message: string) => showAlert("success", message);
export const showInfoAlert = (message: string) => showAlert("info", message);
export const showWarningAlert = (message: string) => showAlert("warning", message);
export const showErrorAlert = (message: string) => showAlert("error", message);
